import { memo } from "react"

type Props = {
  title?: string
  artist?: string
}

function AlbumText({ title, artist }: Props) {
  return (
    <div className="flex flex-col min-w-0 pr-3">
      <span className="text-[var(--primary-color)] text-sm font-semibold truncate">
        {title}
      </span>
      <span className="opacity-40 text-[var(--primary-color)] text-xs truncate">
        {artist || "Mixtape"}
      </span>
    </div>
  )
}

export default memo(AlbumText)